const highAccuracyLocationTimeout = 10000;

const state = {
  latitude: null,
  longitude: null,
  status: 'unasked',
  userLocale: typeof navigator !== 'undefined' ? navigator.language : 'en-US',
  debugMode: false
};

const getters = {
  getUserLocation: state => state,
  getLocationStatus: state => state.status
};

const actions = {
  async setUserLocation({ commit, dispatch, state }) {
    try {
      const position = await new Promise((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(resolve, reject, {
          enableHighAccuracy: true,
          timeout: highAccuracyLocationTimeout
        });
      });

      const { longitude, latitude } = position.coords;
      commit('setUserLocation', { latitude, longitude });

      if (state.debugMode) {
        setInterval(() => {
          dispatch('debugMove');
        }, 1000);
      }
    } catch (highAccuracyError) {
      console.error(
        'Error retrieving high-accuracy location, retrying with low accuracy:',
        highAccuracyError
      );

      try {
        const position = await new Promise((resolve, reject) => {
          navigator.geolocation.getCurrentPosition(resolve, reject, {
            enableHighAccuracy: false,
            timeout: 30000
          });
        });

        const { longitude, latitude } = position.coords;
        commit('setUserLocation', { latitude, longitude });

        if (state.debugMode) {
          setInterval(() => {
            dispatch('debugMove');
          }, 1000);
        }
      } catch (lowAccuracyError) {
        console.error(
          'Error retrieving user location with low accuracy:',
          lowAccuracyError
        );
        let promptable = false;
        try {
          if (navigator.permissions?.query) {
            const permission = await navigator.permissions.query({ name: 'geolocation' });
            promptable = permission.state === 'prompt';
          }
        } catch (permissionError) {
          promptable = false;
        }
        commit('setLocationStatus', promptable ? 'unasked' : 'denied');
      }
    }
  },

  debugMove({ commit, state }) {
    const { latitude, longitude } = state;
    const mileInDegrees = 1 / 69;
    const newLatitude = latitude + mileInDegrees;
    const newLongitude =
      longitude + mileInDegrees / Math.cos((latitude * Math.PI) / 180);

    commit('setUserLocation', {
      latitude: newLatitude,
      longitude: newLongitude
    });
  }
}

const mutations = {
  setUserLocation(state, { latitude, longitude }) {
    state.latitude = latitude;
    state.longitude = longitude;
    state.status = 'granted';
  },
  setLocationStatus(state, status) {
    state.status = status;
  }
}

export default {
  namespaced: true,
  actions,
  getters,
  mutations,
  state
};
